import { CM_BASE_URL } from '../../pages/constants/cmConstants';
import { axios } from './common';
import { convertFilterEpochForBackend } from '../../util/timezone';

export const fetchInvestigatorWorkload = async ({ dashboardFilter }) => {
  const params = dashboardFilter
    ? {
        from: convertFilterEpochForBackend(dashboardFilter.from),
        to: convertFilterEpochForBackend(dashboardFilter.to)
      }
    : null;

  console.log('fetchInvestigatorWorkload');
  const response = await axios.get(`${CM_BASE_URL}/cases/workloads`, {
    params
  });

  if (response.status !== 200) {
    throw { message: 'Failed to fetch investigator workload' };
  }

  return response.data;
};
